import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IGroup } from "src/services/types";
import { toast } from 'react-toastify';
import { Col, Row } from "reactstrap";
import { ColumnsGroups } from "./ColumnsGroups";
import { getGroups } from "src/services/group-service";
import { CreateUpdateGroupModal } from "./CreateUpdateGroupModal";
import { ConfirmDeleteGroupModal } from "./ConfirmDeleteGroupModal";

export const Groups = () => {
    document.title = "Secure | Groups";

  const [isLoading, setIsLoading] = useState(false);
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [groupSelected, setGroupSelected] = useState<IGroup | null>(null);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    const res = await getGroups()
    setIsLoading(false);
    if (res.result === 'ok') {
        setGroups(res.data);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const onEdit = async (item: IGroup) => {
    setGroupSelected(item);
    setShowGroupModal(true);
  }

  const refresh = () => {
    getData();
  }

  const onDelete = async (item: IGroup) => {
    setGroupSelected(item);
    setShowDeletedModal(true);
  }

  const onCreateEdit = (item: IGroup | null) => {
    setGroupSelected(item);
    setShowGroupModal(true);
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="page-content">
          <h3 className="text-primary">Groups</h3>
          <Row className="mb-2">
              <Col sm={6} className="d-flex align-items-center ">
                <button
                    type="button"
                    className="btn btn-soft-secondary waves-effect waves-light me-2"
                    onClick={refresh}
                >
                    <i className="fas fa-sync-alt"></i> Refresh
                </button>
                <button
                    type="button"
                    className="btn btn-soft-success waves-effect waves-light"
                    onClick={(e) => (onCreateEdit(null), e.currentTarget.blur()) }
                >
                    <i className="fas fa-plus"></i> Add group
                </button>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
            <DataTable
                columns={ColumnsGroups( onEdit, onDelete)}
                data={groups}
                pagination
                responsive
                paginationPerPage={20}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                noDataComponent={
                    <SectionNoData
                        onRefresh={() => getData()}
                        isLoading={isLoading}
                    />
                }
            />
          </ContentDataTable>
      </div>

      <CreateUpdateGroupModal
        show={showGroupModal}
        onClose={() => setShowGroupModal(false)}
        onRefresh={getData}
        item={ groupSelected }
      />

        <ConfirmDeleteGroupModal
            show={showDeletedModal}
            onClose={() => setShowDeletedModal(false)}
            onRefresh={refresh}
            item={groupSelected!}
        />

    </>
  )
}
